import {
  Checkbox,
  FormControlLabel,
  List,
  ListItem,
  ListItemText
} from '@mui/material';
import { formatDate } from '../../libs/date';
import { getForm } from '../../libs/formData';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import CommonIconButton from '../../components/CommonIconButton';
import Context from '../../provider';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import React, { useContext, useEffect, useState } from 'react';
import config from '../../config';
import './index.scss';

export default function TierInfoListCheckComponent(props) {
  const {
    membershipRecord,
    tier,
    tierType,
    tierColor,
    fileInfo,
    onNext
  } = props;

  const { t } = useTranslation();
  const navigate = useNavigate();

  const { lang, isMobile, dispatch } = useContext(Context);

  const [membershipFormRecord, setMembershipFormRecord] = useState(null);
  const [filename, setFilename] = useState("");
  const [typeForm, setTypeForm] = useState([]);

  const [activeNext, setActiveNext] = React.useState(false);

  useEffect(() => {
    if (membershipFormRecord) {
      if (typeForm.length > 0) {
        const isRequest = typeForm.every((item) => {
          if (item.group === 2) {
            if (item.isRequest) {
              if (item.type === "check") {
                return membershipFormRecord[item.id] === "1";
              }
            }
          }

          return true;
        });

        setActiveNext(isRequest);
      }
    } else {
      setActiveNext(false);
    }
  }, [membershipFormRecord]);

  useEffect(() => {
    if ( tierType && tierType !== '') {
      setTypeForm(getForm(tierType));
    }
  }, [tierType]);

  useEffect(() => {
    if (fileInfo) {
      setFilename(fileInfo.name);
    }
  }, [fileInfo]);

  useEffect(() => {
    if (membershipRecord) {
      setMembershipFormRecord(membershipRecord);
    }
  }, [membershipRecord]);

  return (
    <>
      <List className={`${isMobile ? 'mobile' : 'web'}-summary-list`}>
        { membershipFormRecord && Object.keys(membershipFormRecord).map((key) => {
            let showKeys = [];
            typeForm.map((formItem) => {
              showKeys.push(formItem.id);
            });

            if (key === 'membership_type') {
              return (
                <ListItem key={key} className="list-item">
                  <div
                    className="list-item-tier-text"
                  >
                    <span>Tier</span>
                    <div
                      style={{ backgroundColor: `${tierColor}` }}
                      className="tier-text"
                    >
                      <p>{t(`tier-name.${membershipFormRecord[key]}`)}</p>
                    </div>
                  </div>
                </ListItem>
              );
            }

            if (showKeys.includes(key) && membershipFormRecord[key] && membershipFormRecord[key] !== "") {
              if (key === "consent_hkdc_tnc" || key === "consent_join_member" || key === "consent_transfer_data") {
                return null;
              }
              let content = membershipFormRecord[key];
              let title = t(`registration.${key}`);
              if (key === "br_images" || key === "student_card_images") {
                console.log('student_card_images: ', membershipFormRecord[key]);

                content = filename;
              }
              if (key === "dob" || key === "expected_grad_date") {
                const showYear = key === "dob" ? 1 : 0;
                content = formatDate(membershipFormRecord[key], lang, showYear);
              }
              if (key === "preference_language") {
                 content = "English";
                if (membershipFormRecord[key] === "zh-HK") {
                  content = "繁體";
                } else if (membershipFormRecord[key] === "zh-CN") {
                  content = "简体";
                }
              }
              if (key === "aware_hkdc_channel" || key === "title") {
                content = t(`registration.${membershipFormRecord[key]}`);
              }

              if (key === "aware_hkdc_channel_event" || key === "aware_hkdc_channel_other") {
                  title = t(`registration.${membershipFormRecord.aware_hkdc_channel}`);
              }
              return (
                <ListItem key={key} className="list-item">
                  <ListItemText
                    className="list-item-text"
                    primary={title}
                    secondary={content}
                  />
                </ListItem>
              );
            }
          })
        }
      </List>
      {
        membershipFormRecord &&
        <>
          <div className={`${isMobile ? 'mobile' : 'web'}-money-text-cont`}>
            <span>{t('registration.discounted-amount')}</span>
            <div className="money-text">
              <p>{`$${membershipFormRecord.discount}`}</p>
            </div>
          </div>
          <div className={`${isMobile ? 'mobile' : 'web'}-money-text-cont`}>
            <span>{t('registration.amount-total')}</span>
            <div className="money-text">
              <span className="original-money-text">
                { membershipFormRecord.net_amount !== membershipFormRecord.membership_fee ? `$${membershipFormRecord.membership_fee}` : ''}
              </span>
              <span className="discounted-money-text">{`$${membershipFormRecord.net_amount}`}</span>
            </div>
          </div>
        </>
      }

      {membershipFormRecord && typeForm && typeForm.length > 0 &&
          typeForm.map((formItem, index) => {
            if (formItem.group !== 2) return null;
            switch (formItem.type) {
              case "check":
                return (
                  <FormControlLabel
                    key={index}
                    className={`${isMobile ? 'mobile' : 'web'}-check-box`}
                    sx={{
                      alignItems: 'flex-start',
                      margin: 0,
                      color: membershipFormRecord[formItem.id] !== '1' && formItem.id !== 'consent_transfer_data' ? '#d32f2f' : undefined
                    }}
                    control={
                      <Checkbox
                      defaultChecked={membershipFormRecord[formItem.id] === '1'}
                      onChange={(e) => {
                        e.stopPropagation();
                        setMembershipFormRecord({ ...membershipFormRecord, [formItem.id]: e.target.checked ? '1' : '0' });
                    }} />}
                    label={
                      t(formItem.label) &&
                      t(formItem.label).split('-')
                          .map((item, index) => {
                            if (index === 1) {
                              return (
                                <span
                                  key={index}
                                  style={{ textDecorationLine: 'underline', color: '#004899' }}
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    navigate(`${config.basename}${"terms-and-condition"}`);
                                    console.log('SET_REGISTRATION_DATA', fileInfo);

                                    dispatch({ type: 'SET_REGISTRATION_DATA', payload: {
                                      isSave: true,
                                      tier: tier,
                                      formFile: fileInfo,
                                      data: membershipRecord,
                                      step: 2
                                    } });
                                  }}
                                >{item}</span>
                              );
                            } else if (index === 3) {
                              return (
                                <span
                                key={index}
                                style={{ textDecorationLine: 'underline', color: '#004899' }}
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    navigate(`${config.basename}${"privacy-policy"}`);
                                    dispatch({ type: 'SET_REGISTRATION_DATA', payload: {
                                      isSave: true,
                                      tier: tier,
                                      formFile: fileInfo,
                                      data: membershipRecord,
                                      step: 2
                                    } });
                                  }}
                                >{item}</span>
                              );
                            } else {
                              return <span key={index}>{item}</span>;
                            }
                          })
                    }
                  />
                );
              default:
                return null;
            }
          })
      }
      <div className="full-width">
        <CommonIconButton
          text={t('common.next-btn')}
          endIcon= {<KeyboardArrowRightIcon />}
          disabled={!activeNext}
          backgroundColor= {!activeNext ? '#C6C6C5' : '#004899'}
          btnColor = "#ffffff"
          btnWidth= { isMobile ? '8.75rem' : "15.26rem"}
          padding = { isMobile ? "0.375rem 1.75rem" : "0.625rem 3rem"}
          btnFontSize = { isMobile ? "1.125rem" : "1.9375rem"}
          btnFontWeight = { isMobile ? "700" : "500"}
          onClick={(e) => {
            e.stopPropagation();
            onNext(membershipFormRecord);
          }}
        />
      </div>
    </>
  );
}